module.exports = __webpack_public_path__ + "static/oldlogo-4a848fd9e1bd9eab9857796890396668.png";